import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
  CImage,
} from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilApplicationsSettings, cilMenu, cilUser } from "@coreui/icons";

import { AppBreadcrumb } from "./index";
import { setAside, setSideBar } from "src/Slices/SideBarSlice";
import AuthService from "./modules/auth/redux/AuthService";

const AppHeader = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector(
    ({ sideBarState }) => sideBarState.sidebarShow
  );
  const user =
    AuthService.GetCurrentUser().userData.roles.includes("TB") ||
      (AuthService.GetCurrentUser().userData.roles.includes("admin") &&
        AuthService.GetCurrentUser().userData.roles.includes("SAK") &&
        AuthService.GetCurrentUser().userData.roles.includes("SABAK"))
      ? AuthService.GetCurrentUser().userData.roles[1]
      : AuthService.GetCurrentUser().userData.roles.includes("Kurum")
        ? AuthService.GetCurrentUser().userData.roles[1]
        : AuthService.GetCurrentUser().userData.roles[1];
  const asideShow = useSelector(({ sideBarState }) => sideBarState.asideShow);
  function clickHandlerLogout() {
    localStorage.clear();
    window.location.reload(false);
  }

  const userName = AuthService.GetCurrentUser().userData.salesPersonName;

  return (
    <>
      <CHeader position="sticky" className="mb-4">
        <CContainer fluid>
          <CHeaderToggler
            className="ps-1"
            onClick={() => dispatch(setSideBar(!sidebarShow))}
          >
            <CIcon icon={cilMenu} size="lg" />
          </CHeaderToggler>
          <CHeaderBrand className="mx-auto d-md-none" to="/">
            <CImage src="/sabakLogo.png" height={48} alt="Logo" />
            {/* <CIcon icon={logo} height={48} alt="Logo" /> */}
          </CHeaderBrand>
          <CHeaderNav className="d-none d-md-flex me-auto">
            <CNavItem>
              <CNavLink
                to="/dashboard"
                component={NavLink}
              // activeClassName="active"
              >
                Dashboard
              </CNavLink>
            </CNavItem>
          </CHeaderNav>

          <div className="me-3">{userName}</div>
          <button
            className="btn btn-danger text-white"
            onClick={clickHandlerLogout}
          >
            <div className="">
              <i className="bi bi-box-arrow-in-left ps-1"></i>
              {/* Oturumu Kapat */}
            </div>
          </button>
          {/* <CHeaderToggler
            className="px-md-0 me-md-3"
            onClick={() => dispatch(setAside(!asideShow))}
          >
            <button className="btn btn-danger text-white" onClick={clickHandlerLogout}>
              <div className=""><i class="icon-signout"></i> Oturumu Kapat</div>
            </button>
          </CHeaderToggler> */}
        </CContainer>
        <CHeaderDivider />
        <CContainer fluid>
          <AppBreadcrumb />
        </CContainer>
      </CHeader>
    </>
  );
};

export default AppHeader;
